export const DOMAIN = 'dsarRequestDetails';
